/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shopping_Recipes_CountInputs */

const en_shopping_recipes_count = /** @type {(inputs: Shopping_Recipes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recipes on the list (${i?.count})`)
};

const de_shopping_recipes_count = /** @type {(inputs: Shopping_Recipes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rezepte auf der Liste (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Recipes on the list ({count})" |
*
* @param {Shopping_Recipes_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_recipes_count = /** @type {((inputs: Shopping_Recipes_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Recipes_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_recipes_count(inputs)
	return en_shopping_recipes_count(inputs)
});